import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { BehaviorSubject } from 'rxjs';

import { routes } from './app.routes';
import { environment } from '../environments/environment';
import { appinfo } from './appinfo';

import {
  GeaMesCognitoModule,
  GeaMesAuthInterceptor,
  COGNITO_CONFIG_HA,
  APPLICATION_NAME,
  ALLOW_SCREENAUTH,
  APIGATEWAY_CONFIG
} from '@gea-mes/cognito';

import {
  GEA_MES_NAVBAR_APPLICATION_NAME,
  GEA_MES_NAVBAR_MENU_SERVICE,
  GEA_MES_NAVBAR_ENV_PROD_STATUS,
  GEA_ENVIROMENT,
  NavItem
} from '@gea-mes/navbar';

import { CanDeactivateGuard } from './work/services/can-deactivate-guard.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    importProvidersFrom(GeaMesCognitoModule),

    { provide: COGNITO_CONFIG_HA, useValue: environment.cognitoOptionsHA },
    { provide: LocationStrategy, useClass: PathLocationStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: GeaMesAuthInterceptor, multi: true },
    { provide: APPLICATION_NAME, useValue: appinfo.name.toUpperCase() },
    { provide: APIGATEWAY_CONFIG, useValue: environment.apiGateway },
    { provide: ALLOW_SCREENAUTH, useValue: environment.AllowScreenAuth },

    { provide: GEA_MES_NAVBAR_APPLICATION_NAME, useValue: appinfo.name.toUpperCase() },
    { provide: GEA_MES_NAVBAR_ENV_PROD_STATUS, useValue: environment.production },
    { provide: GEA_ENVIROMENT, useValue: environment },
    { provide: GEA_MES_NAVBAR_MENU_SERVICE, useValue: new BehaviorSubject<NavItem[]>([]) },

    CanDeactivateGuard
  ]
};